enum Currencies {
    USD = 147,
    EUR = 44,
    AUD = 8
}
export default Currencies;